import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultSchemesDiscountData, getSchemesDiscountById, manageSchemesDiscount, getSchemesDiscounts } from '@/api/schemes-discounts';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getQuery } from '@/utils';
import { getSchemeById } from '@/api/schemes';
import { getDealersRoles } from '@/api/dealers-roles';
import { getStates } from '@/api/locations/states';
import { getAgents } from '@/api/agents';
import { getRanges } from '@/api/ranges';
import { getCategories, getCategoryById } from '@/api/categories';
import { getProductById, getVariations, searchProducts } from '@/api/products';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultSchemesDiscountData);
    this.loading = false;
    this.schemeId = 0;
    this.productList = [];
    this.roleList = [];
    this.stateList = [];
    this.agentList = [];
    this.rangeList = [];
    this.categoryList = [];
    this.subCategoryList = [];
    this.schemesDiscountList = [];
    this.variationIdRowsCount = {};
    this.selectedProduct = null;
    this.disableVariation = true;
    // product is optional for mobile schemes: range / category / sub category only
    this.isMobileScheme = false;
    // the record opened in edit mode, reused when its scope is changed
    this.originalRecord = null;
    // saved rows removed from the table, disabled on save
    this.removedRows = [];
    this.rules = {};
  }
  get isScopeMode() {
    return !this.formData.productId && this.isMobileScheme && !!(this.formData.rangeId || this.formData.categoryId || this.formData.subCategoryId);
  }
  get showTable() {
    return !!this.formData.productId || this.isScopeMode;
  }
  get scopeLabel() {
    const find = (list, id) => (list.find(item => +item.id === +id) || {}).name;
    const name = this.formData.subCategoryId && find(this.subCategoryList, this.formData.subCategoryId) || this.formData.categoryId && find(this.categoryList, this.formData.categoryId) || this.formData.rangeId && find(this.rangeList, this.formData.rangeId);
    return `All products in ${name || 'selected scope'}`;
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultSchemesDiscountData);
      // assign scheme ID
      this.schemeId = parseInt(this.$route.params && this.$route.params.schemeId);
      this.formData.schemeId = this.schemeId;
      this.originalRecord = null;
      this.removedRows = [];
      this.schemesDiscountList = [];
      this.fetchScheme();
    }
    // get dealers roles
    this.fetchDealersRoles();
    // get states
    this.fetchStates();
    // get agents
    this.fetchAgents();
    // get ranges
    this.fetchRanges();
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      this.loading = true;
      const data = await getSchemesDiscountById(id);
      this.formData = data;
      this.schemeId = data.schemeId;
      this.originalRecord = {
        ...data
      };
      this.removedRows = [];
      await this.fetchScheme();
      // fetch category if mapped
      if (this.formData.categoryId) {
        const category = await getCategoryById(this.formData.categoryId);
        this.categoryList = [category];
      }
      // fetch sub category if mapped
      if (this.formData.subCategoryId) {
        const subCategory = await getCategoryById(this.formData.subCategoryId);
        this.subCategoryList = [subCategory];
      }
      // fetch product if mapped
      if (this.formData.productId) {
        this.selectedProduct = await getProductById(this.formData.productId);
        this.productList = [this.selectedProduct];
        // fetch variations
        this.fetchVariantions();
      } else {
        // range / category / sub category level discount
        this.loadRows();
      }
      // Just for test
      const title = '#' + this.formData.id;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  }
  async fetchDealersRoles() {
    this.roleList = await getDealersRoles(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchStates() {
    this.stateList = await getStates(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchAgents() {
    this.agentList = await getAgents(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchRanges() {
    this.rangeList = await getRanges(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchCategories() {
    // reset category and subcategory
    this.formData.categoryId = null;
    this.formData.subCategoryId = null;
    this.formData.productId = null;
    this.productList = [];
    this.categoryList = await getCategories(getQuery({
      enabled: true,
      rangeId: this.formData.rangeId,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq',
        parentId: '$isnull',
        rangeId: '$eq'
      }
    }));
    await this.loadRows();
  }
  async fetchSubCategories() {
    // reset subcategory
    this.formData.subCategoryId = null;
    this.formData.productId = null;
    this.productList = [];
    this.subCategoryList = await getCategories(getQuery({
      enabled: true,
      parentId: this.formData.categoryId,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq',
        parentId: '$eq'
      }
    }));
    await this.loadRows();
  }
  async resetProducts() {
    this.formData.productId = null;
    this.productList = [];
    await this.loadRows();
  }
  async fetchScheme() {
    try {
      const scheme = await getSchemeById(this.schemeId);
      this.isMobileScheme = !!scheme.forMobile;
    } catch (err) {
      this.isMobileScheme = false;
    }
  }
  // product picked / cleared or scope changed: (re)build the table rows
  async loadRows() {
    this.removedRows = [];
    if (this.formData.productId) {
      await this.fetchVariantions();
    } else {
      await this.loadScopeRows();
    }
  }
  // rows for a discount without product (range / category / sub category)
  async loadScopeRows() {
    this.schemesDiscountList = [];
    this.variationIdRowsCount = {};
    if (!this.isScopeMode) {
      return;
    }
    const sameOrNull = (a, b) => (a !== null && a !== void 0 ? a : null) === (b !== null && b !== void 0 ? b : null);
    const allSaved = await getSchemesDiscounts(getQuery({
      schemeId: this.schemeId,
      sort: ['percentDiscount,ASC'],
      filter: {
        schemeId: '$eq',
        productId: '$isnull'
      }
    }));
    const saved = allSaved.filter(item => item.enabled && sameOrNull(item.dealersRoleId, this.formData.dealersRoleId) && sameOrNull(item.agentId, this.formData.agentId) && sameOrNull(item.stateId, this.formData.stateId) && sameOrNull(item.rangeId, this.formData.rangeId) && sameOrNull(item.categoryId, this.formData.categoryId) && sameOrNull(item.subCategoryId, this.formData.subCategoryId));
    const makeRow = (item = {}) => ({
      id: item.id,
      enabled: true,
      schemeId: this.schemeId,
      dealersRoleId: this.formData.dealersRoleId,
      stateId: this.formData.stateId,
      agentId: this.formData.agentId,
      rangeId: this.formData.rangeId,
      categoryId: this.formData.categoryId,
      subCategoryId: this.formData.subCategoryId,
      productId: null,
      productsVariation: {
        id: 'null',
        name: this.scopeLabel
      },
      looseQuantity: item.minimumQuantity || 0,
      cartonQuantity: 0,
      minimumQuantity: item.minimumQuantity || 0,
      percentDiscount: item.percentDiscount || 0,
      isEach: !!item.isEach,
      isPieces: !!item.isPieces,
      isMixed: !!item.isMixed
    });
    if (saved.length) {
      saved.forEach(item => this.schemesDiscountList.push(makeRow(item)));
    } else if (this.isEdit && this.originalRecord) {
      // the edited record moves to this scope: keep its id and values
      this.schemesDiscountList.push(makeRow(this.originalRecord));
    } else {
      this.schemesDiscountList.push(makeRow());
    }
    this.variationIdRowsCount = {
      null: this.schemesDiscountList.length
    };
    // object keys are strings: use the 'null' key the table rows use
    this.variationIdRowsCount.null = this.schemesDiscountList.length;
  }
  async fetchProducts(query) {
    try {
      let selectedCategoryId = 0;
      if (this.formData.categoryId) {
        selectedCategoryId = this.formData.categoryId;
      }
      if (this.formData.subCategoryId) {
        selectedCategoryId = this.formData.subCategoryId;
      }
      if (query.length > 2) {
        const productParams = {
          keyword: query,
          rangeId: this.formData.rangeId || undefined,
          searchByCatalogueCode: false
        };
        if (selectedCategoryId) {
          productParams.categoryId = selectedCategoryId;
        }
        this.productList = await searchProducts(getQuery(productParams));
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchVariantions() {
    this.schemesDiscountList = [];
    if (this.formData.productId && this.formData.dealersRoleId) {
      // get selected product
      this.selectedProduct = await getProductById(this.formData.productId);
      const productId = this.formData.productId;
      const dealersRoleId = this.formData.dealersRoleId;
      const variations = await getVariations(getQuery({
        productId,
        sort: 'name,ASC',
        filter: {
          productId: '$eq'
        }
      }));
      // product without any variation rows: use the product itself (null variation)
      if (!variations.length) {
        variations.push({
          id: 'null',
          name: this.selectedProduct.name
        });
        this.disableVariation = true;
      }
      // map data
      if (variations.length) {
        this.variationIdRowsCount = {};
        // default add product with null variation
        if (this.selectedProduct.productType === 'variable') {
          const defaultProduct = JSON.parse(JSON.stringify(variations[0]));
          defaultProduct.id = 'null';
          defaultProduct.name = this.selectedProduct.name;
          variations.unshift(defaultProduct);
        } else {
          this.disableVariation = false;
        }
        await this.mapToSchemeDiscounts(dealersRoleId, productId, variations);
      }
    }
  }
  async mapToSchemeDiscounts(dealersRoleId = 0, productId = 0, variations = []) {
    // check if variation already saved to scheme discounts
    const allSaved = await getSchemesDiscounts(getQuery({
      dealersRoleId,
      productId,
      sort: ['productsVariationId,ASC', 'percentDiscount,ASC'],
      filter: {
        productId: '$eq',
        dealersRoleId: '$eq'
      }
    }));
    // only rows of the same scheme / agent / state belong to this form,
    // otherwise saving would move other schemes' discounts into this one
    const savedVariations = allSaved.filter(item => {
      var _item$agentId, _this$formData$agentI, _item$stateId, _this$formData$stateI;
      return +item.schemeId === +this.schemeId && ((_item$agentId = item.agentId) !== null && _item$agentId !== void 0 ? _item$agentId : null) === ((_this$formData$agentI = this.formData.agentId) !== null && _this$formData$agentI !== void 0 ? _this$formData$agentI : null) && ((_item$stateId = item.stateId) !== null && _item$stateId !== void 0 ? _item$stateId : null) === ((_this$formData$stateI = this.formData.stateId) !== null && _this$formData$stateI !== void 0 ? _this$formData$stateI : null);
    });
    // map variation ID to each object
    const schemeObj = savedVariations.reduce((acc, obj) => {
      this.disableVariation = false;
      if (obj.enabled && !obj.productsVariationId) {
        this.disableVariation = true;
      }
      if (!acc[obj.productsVariationId]) {
        acc[obj.productsVariationId] = [obj];
      } else {
        acc[obj.productsVariationId].push(obj);
      }
      return acc;
    }, {});
    for (const variant of variations) {
      if (this.variationIdRowsCount[variant.id]) {
        this.variationIdRowsCount[variant.id] += 1;
      } else {
        this.variationIdRowsCount[variant.id] = 1;
      }
      const objToSave = {
        enabled: true,
        schemeId: this.schemeId,
        dealersRoleId: this.formData.dealersRoleId,
        stateId: this.formData.stateId,
        agentId: this.formData.agentId,
        rangeId: this.formData.rangeId,
        categoryId: this.formData.categoryId,
        subCategoryId: this.formData.subCategoryId,
        productId,
        productsVariation: {
          id: variant.id,
          name: variant.name
        },
        looseQuantity: 0,
        cartonQuantity: 0,
        minimumQuantity: 0,
        percentDiscount: 0,
        isEach: false,
        isPieces: false,
        isMixed: false
      };
      if (Object.prototype.hasOwnProperty.call(schemeObj, variant.id)) {
        let rowIndex = 0;
        for (const item of schemeObj[variant.id]) {
          const subObj = {
            ...objToSave,
            ...{}
          };
          subObj.id = item.id;
          subObj.looseQuantity = item.minimumQuantity;
          subObj.minimumQuantity = item.minimumQuantity;
          subObj.percentDiscount = item.percentDiscount;
          subObj.isEach = !!item.isEach;
          subObj.isPieces = !!item.isPieces;
          subObj.isMixed = !!item.isMixed;
          this.schemesDiscountList.push(subObj);
          if (rowIndex > 0) {
            this.variationIdRowsCount[variant.id] += 1;
          }
          rowIndex++;
        }
      } else {
        this.schemesDiscountList.push(objToSave);
      }
    }
  }
  addRow(index, row) {
    const newRow = {
      enabled: true,
      schemeId: this.schemeId,
      dealersRoleId: this.formData.dealersRoleId,
      stateId: this.formData.stateId,
      agentId: this.formData.agentId,
      rangeId: this.formData.rangeId,
      categoryId: this.formData.categoryId,
      subCategoryId: this.formData.subCategoryId,
      productId: row.productId,
      productsVariation: {
        id: row.productsVariation.id,
        name: row.productsVariation.name
      },
      looseQuantity: 0,
      cartonQuantity: 0,
      minimumQuantity: 0,
      percentDiscount: 0,
      isEach: false,
      isPieces: false,
      isMixed: false
    };
    this.schemesDiscountList.splice(index + 1, 0, newRow);
    this.variationIdRowsCount[row.productsVariation.id] += 1;
  }
  removeRow(index, row) {
    const key = row.productsVariation.id;
    // the actions cell spans the whole group: remove the last row of it
    const lastIndex = index + this.variationIdRowsCount[key] - 1;
    const target = this.schemesDiscountList[lastIndex];
    if (!target) {
      return;
    }
    // saved rows are disabled on save, new rows are simply dropped
    if (target.id) {
      this.removedRows.push({
        id: target.id,
        enabled: false
      });
    }
    this.schemesDiscountList.splice(lastIndex, 1);
    this.variationIdRowsCount[key] -= 1;
  }
  objectSpanMethod(args) {
    const {
      row,
      column,
      rowIndex,
      columnIndex
    } = args;
    if ([0, 8].includes(columnIndex) && row.productsVariation.id) {
      // check row - 1 has same variation id
      if (rowIndex > 0) {
        const prevRow = this.schemesDiscountList[rowIndex - 1];
        if (prevRow.productsVariation.id === row.productsVariation.id) {
          return {
            rowspan: this.variationIdRowsCount[row.productsVariation.id],
            colspan: 0
          };
        }
      }
      return {
        rowspan: this.variationIdRowsCount[row.productsVariation.id],
        colspan: 1
      };
    }
    return 0;
  }
  quantityChange(index, qtyType = 'carton') {
    switch (qtyType) {
      case 'pieces':
        this.schemesDiscountList[index].cartonQuantity = 0;
        this.schemesDiscountList[index].minimumQuantity = this.schemesDiscountList[index].looseQuantity;
        break;
      case 'carton':
        this.schemesDiscountList[index].looseQuantity = 0;
        this.schemesDiscountList[index].minimumQuantity = this.schemesDiscountList[index].cartonQuantity * this.selectedProduct.masterCarton;
        break;
      default:
        break;
    }
    // validate percent
    this.validatePercent(index);
  }
  validatePercent(index) {
    if (this.schemesDiscountList[index].minimumQuantity) {
      if (!this.schemesDiscountList[index].percentDiscount) {
        this.schemesDiscountList[index].percentDiscount = '1';
      }
    } else {
      this.schemesDiscountList[index].percentDiscount = 0;
    }
  }
  toggleInput(row) {
    // discount without product has a single, always editable row
    if (!this.formData.productId) {
      return false;
    }
    if (this.disableVariation) {
      if ([null, 'null'].includes(row.productsVariation.id)) {
        return false;
      } else {
        return true;
      }
    } else {
      if ([null, 'null'].includes(row.productsVariation.id)) {
        return true;
      } else {
        return false;
      }
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        // either gst or vehicle number must be filled
        if (!this.formData.dealersRoleId && !this.formData.agentId && !this.formData.stateId) {
          this.$message({
            message: 'Either Dealers Role or Agent or State is required',
            type: 'warning'
          });
          return false;
        }
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      for (const scheme of this.schemesDiscountList) {
        // rows were built when the product was picked: re-apply the scope as it
        // is now, so editing role / state / agent / range / category takes effect.
        // a cleared select gives '' / undefined: always store these as null
        for (const key of ['dealersRoleId', 'stateId', 'agentId', 'rangeId', 'categoryId', 'subCategoryId']) {
          scheme[key] = this.formData[key] || null;
        }
        scheme.productId = this.formData.productId || null;
        scheme.schemeId = this.schemeId;
        if (scheme.productsVariation.id === 'null') {
          scheme.productsVariation.id = null;
        }
        // remove rows with quantity: 0
        if (scheme.minimumQuantity === 0) {
          scheme.enabled = false;
        } else {
          scheme.enabled = !this.toggleInput(scheme);
        }
      }
      if (!this.schemesDiscountList.length) {
        this.$message({
          message: 'Select a range, category, sub category or product first',
          type: 'warning'
        });
        this.loading = false;
        return;
      }
      // new rows without quantity are not worth saving
      const toSave = this.schemesDiscountList.filter(scheme => scheme.id || scheme.minimumQuantity > 0);
      if (!toSave.length && !this.removedRows.length) {
        this.$message({
          message: 'Enter a quantity and discount for at least one row',
          type: 'warning'
        });
        this.loading = false;
        return;
      }
      await manageSchemesDiscount([...toSave, ...this.removedRows]);
      this.$notify({
        title: 'Success',
        message: 'Scheme discount saved',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      // back to the list; it is empty until a filter is set, so pass the role
      const query = {};
      if (this.formData.dealersRoleId) {
        query.dealersRoleId = this.formData.dealersRoleId;
      }
      router.push({
        path: '/schemes-discounts/list/' + this.schemeId,
        query
      });
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'SchemesDiscountDetail',
  components: {}
})], default_1);
export default default_1;